import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Global } from '@services/global.service';
import { Menu as MenuService} from '@services/menu.service';
import { Router } from '@services/route.service';
import { ScannerService } from '@services/scanner.service';
import { User } from '@services/user.service';

@Component({
  selector: 'lgb-menu',
  imports: [
    RouterModule,
    CommonModule
  ],
  templateUrl: './menu.html',
  styleUrl: './menu.css',
})
export class Menu {
  readonly menu=inject(MenuService);
  readonly router=inject(Router);
  readonly scanService=inject(ScannerService);
  readonly userS=inject(User);
  readonly globalS=inject(Global);
  readonly canAdmin=computed(() => this.userS.user()?.rights.length>0);

  scanPage(){
    this.scanService.enable('binder', this.menu.target());
  }

  refreshCard(){
    this.scanService.enable('card', this.menu.target());
  }

  getSelectStyle(){
    let margin: string='0px';
    switch(this.menu.action()){
      case 'binder': 
        margin='0px';
        break;
      case 'page': 
        margin='-2rem';
        break;
      case 'card': 
        margin='-4rem';
        break;
    }

    return {
      'margin-left': margin
    }
  }
}
